import { gql, TypedDocumentNode } from '@apollo/client';
import type { Product } from '../models/Product';
import type { ProductBulkPricingMarkupLineItem } from '../models/ProductBulkPricingMarkupLineItem';

export const ADD_PRODUCT_MUTATION: TypedDocumentNode<{ added: boolean }, { input: Product }> = gql`
  mutation AddProduct($input: ProductModelInput!) {
    added: addProduct(input: $input)
  }
`;

export const UPDATE_PRODUCT_MUTATION: TypedDocumentNode<{ updatedProduct: Product }, { input: Product }> = gql`
  mutation UpdateProduct($input: ProductModelInput!) {
    updatedProduct: updateProduct(input: $input) {
      id,
      name,
      items {
        id,
        itemId,
        quantity,
        notes
      }
    }
  }
`;

export const UPDATE_PRODUCT_BULK_PRICING_MARKUP_LINE_ITEMS: TypedDocumentNode<{ updated: boolean }, { updatedBulkPricingMarkupLineItems: ProductBulkPricingMarkupLineItem[] }> = gql`
  mutation UpdateProductBulkPricingMarkupLineItems($updatedBulkPricingMarkupLineItems: [ProductBulkPricingMarkupLineItemModelInput!]!) {
    updated: updateProductBulkPricingMarkupLineItems(updatedBulkPricingMarkupLineItems: $updatedBulkPricingMarkupLineItems)
  }
`;

export const DELETE_PRODUCT_BY_ID_MUTATION: TypedDocumentNode<{ deleted: boolean }, { id: number }> = gql`
  mutation DeleteProductById($id: Int!) {
    deleted: deleteProductById(id: $id)
  }
`;
